module.exports = __WEBPACK_EXTERNAL_MODULE_166__;


//////////////////
// WEBPACK FOOTER
// external "@angular/common"
// module id = 166
// module chunks = 0